/**
 * Geometry shared by the persistent nav panel and the per-page shell.
 *
 * These two live in different components now (the panel is mounted once by
 * the app layout, the shell once per page), so the widths cannot be a local
 * const in either: the spacer the page reserves and the width the panel
 * animates to must be the same number or the content sits under the rail.
 */

import { MOBILE_BREAKPOINT as SHARED_MOBILE_BREAKPOINT } from "../../styles/breakpoints";

/** Collapsed width: icons only. */
export const RAIL = 76;
/** Expanded width: icons + labels. */
export const EXPANDED = 248;
/** Below this viewport width the sidebar becomes an off-canvas drawer. */
export const MOBILE_BREAKPOINT = SHARED_MOBILE_BREAKPOINT;
/** Ready-to-use media query string for the rail ⇄ drawer switch. */
export const MOBILE_QUERY = `(max-width:${MOBILE_BREAKPOINT - 0.05}px)`;
